import { inject } from 'vue'
import { DEPENDENCIES_TOKEN, DependenciesProvider } from '@/core/shared/domain/dependencies.ts'

export const useDependencies = () => inject(DEPENDENCIES_TOKEN) as DependenciesProvider
